module.exports = __webpack_public_path__ + "static/media/avc_cholesterol.b5812684.svg";